<template>
  <v-dialog v-model="isOpen" width="500" persistent>
    <v-card class="pa-4">
      <v-card-title class="ma-0 mb-2 pa-0">
        <h2>Setup Email</h2>
      </v-card-title>
      <v-card-text class="ma-0 mt-2 mb-1 pa-0">
        <v-text-field 
          label="Name" 
          box 
          v-model="name" 
          :rules="[rules.required]"
          :error-messages="nameError"
          @input="clearError"
          autofocus
        ></v-text-field>
        <v-text-field 
          label="Description" 
          box 
          v-model="description"
          :error-messages="descriptionError"
          @input="clearError"
        ></v-text-field>
        <v-alert 
          v-if="errorMessage" 
          :value="true" 
          type="error" 
          class="mt-3 mb-0"
          dismissible
          @input="clearError"
        >
          {{ errorMessage }}
        </v-alert>
      </v-card-text>
      <v-card-actions class="ma-0 mt-3 pa-0">
        <v-btn 
          @click="createAccount" 
          color="success"
          :loading="isCreating"
          :disabled="!name || isCreating"
        >
          Setup
        </v-btn>
        <v-btn 
          @click="cancel" 
          color="secondary"
          :disabled="isCreating"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CreateEmailAccountDialog",
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    name: "",
    description: "",
    errorMessage: "",
    nameError: "",
    descriptionError: "",
    isCreating: false,
    rules: {
      required: value => !!value || "Required."
    }
  }),
  watch: {
    isOpen(newVal) {
      if (newVal) {
        // Reset form when dialog opens
        this.name = ""
        this.description = ""
        this.errorMessage = ""
        this.nameError = ""
        this.descriptionError = ""
        this.isCreating = false
      }
    }
  },
  methods: {
    clearError() {
      this.errorMessage = ""
      this.nameError = ""
      this.descriptionError = ""
    },
    async createAccount() {
      if (!this.name) {
        this.nameError = "Name is required"
        return
      }
      
      this.isCreating = true
      this.clearError()
      
      try {
        const createdAccount = await this.$store.dispatch("addNewEmailAccount", {
          name: this.name.trim(),
          description: this.description.trim()
        })
        
        if (createdAccount) {
          this.$emit("created", createdAccount)
          this.$emit("close")
        } else {
          this.isCreating = false
          this.errorMessage = "Failed to setup email"
        }
      } catch (error) {
        this.isCreating = false
        const errorMsg = error.message || "Failed to setup email"
        this.errorMessage = errorMsg
        
        // Check if it's a duplicate name error and highlight the name field
        if (errorMsg.includes("already exists") || errorMsg.includes("duplicate")) {
          this.nameError = errorMsg.replace("email account", "email setup")
        }
      }
    },
    cancel() {
      this.$emit("close")
    }
  }
}
</script>

